const e = "Konto", n = "Saldo på konto", t = "Kontobeskrivelse", a = "Konto-ID", r = "Tillegg", i = "Justeringer", o = "Beløp", s = "og", l = "Bruk", d = "Tilbake", u = "Saldokonto", c = "Saldokonto-ID", p = "Bestilt", g = "Registrert", k = "Kategori", f = "Chargebacks", m = "Lukk", b = "Kontakt brukerstøtten", v = "Kontakt brukerstøtten for å få hjelp.", y = "Kontakt brukerstøtten for hjelp og del feilkoden %{requestId}", h = "Kopiert", T = "Kopier", R = "Rettelser", A = "Valuta", F = "Dato", P = "Datointervall", j = "Beskrivelse", D = "Avvis", S = "Nedlasting", N = "Later ned", C = "E-post", O = "Entiteten ble ikke funnet", B = "Transaksjon ble ikke funnet for den angitte kontoinnehaveren", I = "Gebyrer", L = "Fil", x = "Filterlinje", w = "Fra", V = "Full", W = "Midler registrert", M = "Gå tilbake", K = "Tilskudd utstedt", G = "Tilbakebetaling av tilskudd", q = "Skjul innhold", E = "ID", U = "Ufullstendig felt", H = "Pågår", Y = "Laster inn", _ = "maks", X = "min", z = "Mobile", J = "Netto utbetaling", Q = "Neste utbetalinger", Z = "Ingen data", $ = "Ingen negative tall tillatt", ee = "Ingen utbetalinger funnet", ne = "Ingen rapporter funnet", te = "Ingen transaksjoner funnet", ae = "Annet", re = "Sideformatert navigasjon", ie = "Delvis", oe = "Betalings-ID", se = "Betalingsmetode", le = "Detaljer om utbetaling", de = "Utbetalingsinformasjon genereres hver dag ved midnatt, UTC-tid.", ue = "Utbetalinger", ce = "Avventer", pe = "Kom tilbake senere.", ge = "Ta kontakt med brukerstøtten for å få hjelp.", ke = "Ta kontakt med brukerstøtten", fe = "Referanse-ID", me = "Oppdater", be = "Refunderinger", ve = "Refunder betaling", ye = "Vi kunne ikke behandle refusjonen. Prøv igjen senere.", he = "Noe gikk galt.", Te = "Kunden din får pengene innen 40 dager. Når refusjonen er vellykket, vil du se en ny refusjonstransaksjon på listen din.", Re = "Refusjon er sendt!", Ae = "Beløp som skal refunderes", Fe = "Refusjoner kan ta opptil 40 dager, avhengig av betalingsmetode. Gebyrer er inkludert.", Pe = "Refunder %{amount}", je = "Årsak til refusjon", De = "Referanse", Se = "Gjenstående beløp", Ne = "Rapport", Ce = "Rapporter genereres hver dag ved midnatt, UTC-tid.", Oe = "Rapporter", Be = "Tilbakestill", Ie = "Omvendt", Le = "Noe gikk galt.", xe = "Noe gikk galt. Prøv å oppdatere siden, eller kom tilbake senere.", we = "Status", Ve = "Strukturert liste", We = "Subtraksjoner", Me = "Summen av utbetalinger samme dag", Ke = "Faner", Ge = "Feilkoden er %{requestId}", qe = "Det finnes ingen resultater", Ee = "Forespørselen mangler obligatoriske felt eller inneholder ugyldige data.", Ue = "Det oppstod en uventet feil", He = "Den valgte saldokontoen er feil", Ye = "Tidssone", _e = "Til", Xe = "Totalt innkommende", ze = "Totalt utgående", Je = "Til-verdien skal være lik eller større enn Fra-verdien", Qe = "Transaksjonsdetaljer", Ze = "Transaksjoner", $e = "Transaksjonsoversikt", en = "Transaksjonstype", nn = "Overføringer", tn = "Prøv et annet søk eller tilbakestill filtrene dine, så prøver vi på nytt.", an = "Prøv å oppdatere siden, eller kom tilbake senere.", rn = "Beløp", on = "Type", sn = "Verdi", ln = "Vi kunne ikke laste inn oversikten over utbetalinger.", dn = "Vi kunne ikke laste inn oversikten over rapporter.", un = "Vi kunne ikke laste inn transaksjonsoversikten.", cn = "Vi kunne ikke laste inn saldokontoene dine.", pn = "Vi kunne ikke laste inn utbetalingene dine.", gn = "Vi kunne ikke laste inn rapportene dine.", kn = "Vi kunne ikke laste inn transaksjonene dine.", fn = {
  account: e,
  accountBalance: n,
  accountDescription: t,
  accountID: a,
  additions: r,
  adjustments: i,
  amount: o,
  and: s,
  apply: l,
  back: d,
  balanceAccount: u,
  balanceAccountId: c,
  Booked: p,
  "button.clearAll": "Fjern alle",
  "calendar.controls": "Kontroller for kalendernavigasjon",
  "calendar.nextMonth": "Neste måned",
  "calendar.previousMonth": "Forrige måned",
  "calendar.timezone": "Tidssonen er satt til: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Kontoen din er inaktiv",
  "capital.actionNeeded": "Handling kreves",
  "capital.bankAccountDetails": "Bankkontoinformasjon",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Kontonummer",
  "capital.bankCountryOrRegion": "Land/region",
  "capital.bankRoutingNumber": "Routingnummer",
  "capital.bankSortCode": "Sort code (Storbritannia/Irland)",
  "capital.businessFinancing": "Bedriftsfinansiering",
  "capital.businessFinancingOffer": "Bedriftsfinansieringstilbud",
  "capital.businessFinancingSummary": "Oppsummering av bedriftsfinansiering",
  "capital.closed": "Lukket",
  "capital.couldNotContinueWithTheOffer": "Vi kunne ikke gå videre med tilbudet.",
  "capital.couldNotLoadFinancialOffers": "Vi kunne ikke laste inn finanstilbud.",
  "capital.dailyRepaymentRate": "Daglig nedbetalingssats",
  "capital.daysAndDaysLeft": "%{days} dager (%{daysLeft} dager igjen)",
  "capital.expectedRepaymentPeriod": "Forventet nedbetalingstid",
  "capital.failed": "Mislykket",
  "capital.fees": "Gebyrer",
  "capital.fullyRepaid": "Nedbetalt i sin helhet",
  "capital.goToTermsAndConditions": "Gå til vilkår",
  "capital.grantID": "Lån-ID",
  "capital.howMuchMoneyDoYouNeed": "Hvor stort beløp trenger du?",
  "capital.inProgress": "Pågår",
  "capital.legalSubtitleAU": "Adyen Capital leveres av Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Lån utstedes av Adyen N.V.",
  "capital.legalSubtitleGB": "Lån utstedes av Adyen N.V., representert ved sin London-filial.",
  "capital.legalSubtitleUS": "Lån utstedes av Adyen N.V. San Francisco-filial og er underlagt kredittgodkjenning.",
  "capital.maximumRepaymentPeriod": "Maksimal nedbetalingstid",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Minimumsavdrag hver %{days}. dag for å nedbetale finansieringen i tide",
  "capital.needSomeExtraMoney": "Trenger du litt ekstra penger?",
  "capital.offerLegalNoticeDescriptionUS": "Hvis søknaden din om bedriftskreditt blir avslått, har du rett til en skriftlig redegjørelse for de spesifikke årsakene til avslaget. For å få redegjørelsen kan du kontakte Adyens Credit Support Team ved å sende en e-post til %{email} innen 60 dager fra datoen du fikk melding om beslutningen. Vi sender deg en skriftlig begrunnelse for avslaget innen 30 dager etter at vi har mottatt forespørselen. %{break} Den amerikanske loven Federal Equal Credit Opportunity Act forbyr kreditorer å diskriminere kredittsøkere basert på etnisitet, hudfarge, religion, nasjonal opprinnelse, kjønn, sivilstand, alder (forutsatt at søkeren har rettsevne til å inngå en bindende kontrakt), at hele eller deler av søkerens inntekt kommer fra et offentlig hjelpeprogram, eller at søkeren i god tro har utøvet en rettighet i henhold til loven Consumer Credit Protection Act. Det føderale byrået som administrerer overholdelse av denne loven angående denne kreditoren er Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Kreditor: Adyen N.V. – San Francisco Branch %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 måned",
  "capital.pending": "Avventer",
  "capital.primaryAccount": "Primærkonto",
  "capital.remaining": "Gjenværende",
  "capital.remainingAmount": "Gjenstående beløp",
  "capital.remainingFees": "Gjenværende gebyrer",
  "capital.repaid": "Nedbetalt",
  "capital.repaidAmount": "Nedbetalt beløp",
  "capital.repaidFees": "Nedbetalte gebyrer",
  "capital.repaymentBalanceInfo": "Ditt nåværende gjenstående beløp, inkludert gebyrer, er %{amount}",
  "capital.repaymentThreshold": "Nedbetalingsterskel",
  "capital.requestedFunds": "Forespurt beløp",
  "capital.requestFunds": "Be om midler",
  "capital.requesting": "Forespør",
  "capital.reviewOffer": "Gjennomgå tilbud",
  "capital.revoked": "Tilbakekalt",
  "capital.seeNewOffer": "Se nytt tilbud",
  "capital.seeOptions": "Se alternativer",
  "capital.sendRepayment": "Send tilbakebetaling",
  "capital.sendRepaymentNotice": "Det kan ta 2–3 virkedager før den ekstra tilbakebetalingen som er overført til lånet ditt, vises på lånekontoen din.",
  "capital.sendRepaymentSubtitle": "Overfør penger til denne bankkontoen for å betale tilbake en del av lånet eller hele lånet ditt.",
  "capital.signTermsAndConditionsToReceiveFunds": "Signer vilkårene for å motta pengene.",
  "capital.signTheTermsToReceiveYourFunds": "Signer vilkårene for å motta pengene",
  "capital.termEnds": "Perioden avsluttes: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Det er ikke konfigurert noen primærkonto",
  "capital.thisOfferExpiresOn": "Dette tilbudet utløper %{date}.",
  "capital.totalFees": "Totale gebyrer",
  "capital.totalRepaymentAmount": "Totalt nedbetalingsbeløp",
  "capital.unsupportedRegionDescription": "Bedriftsfinansiering er ikke tilgjengelig i din region ennå, men kom tilbake senere for å få et tilbud.",
  "capital.unsupportedRegionTitle": "Følg med!",
  "capital.weCouldNotContinueWithTheOffer": "Vi kunne ikke gå videre med tilbudet.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Vi kunne ikke gå videre med tilbudet. Kontakt brukerstøtten for å få hjelp.",
  "capital.weCouldNotLoadFinancialOffers": "Vi kunne ikke laste inn finanstilbud.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Vi kunne ikke behandle denne forespørselen. Prøv igjen med et nytt tilbud.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Vi har mottatt forespørselen din og behandler den nå. Kom tilbake snart for de neste trinnene.",
  "capital.writtenOff": "Avskrevet",
  "capital.xDays": "%{days} dager",
  "capital.xMonths": "%{months} måneder",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Du mottok, men returnerte deretter disse pengene",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Du mottok disse pengene, men tilbakebetalte dem ikke",
  "capital.youAreRequestingFundingOf": "Du ber om finansiering av",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Du er forhåndskvalifisert for bedriftsfinansiering",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " opptil %{amount}.",
  "capital.yourRequestedFundsWere": "Beløpet du ba om, var: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Du bør få pengene innen én virkedag",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Du må betale minst %{amount} hver %{days}. dag for å nedbetale hele beløpet innen %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Du er snart kvalifisert for et finanstilbud!",
  capture: g,
  category: k,
  chargeback: f,
  closeIconLabel: m,
  contactSupport: b,
  contactSupportForHelp: v,
  contactSupportForHelpAndShareErrorCode: y,
  copied: h,
  copy: T,
  correction: R,
  currency: A,
  date: F,
  dateRange: P,
  default: "Standard",
  description: j,
  dismiss: D,
  download: S,
  downloading: N,
  email: C,
  entityWasNotFound: O,
  entityWasNotFoundDetail: B,
  "error.pleaseTryAgainLater": "Prøv igjen senere.",
  "error.somethingWentWrongWithDownload": "Noe gikk galt med nedlastingen",
  "expandableCard.collapse": "Skjul",
  "expandableCard.expand": "Utvid",
  export: "Eksportér",
  fee: I,
  file: L,
  "filter.date.since": "Siden %{date}",
  "filter.date.until": "Frem til %{date}",
  filterBar: x,
  "filterPlaceholder.category": "Type",
  "filterPlaceholder.currency": "Valuta",
  "filterPlaceholder.status": "Status",
  from: w,
  full: V,
  fundsCaptured: W,
  goBack: M,
  grantIssued: K,
  grantRepayment: G,
  hideContent: q,
  id: E,
  incompleteField: U,
  inProgress: H,
  loading: Y,
  max: _,
  min: X,
  mobile: z,
  netPayout: J,
  nextPayouts: Q,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: ne,
  noTransactionsFound: te,
  other: ae,
  paginatedNavigation: re,
  "pagination.nextPage": "Neste side",
  "pagination.previousPage": "Forrige side",
  "pagination.showing": "Viser",
  partial: ie,
  paymentId: oe,
  paymentMethod: se,
  payoutDetails: le,
  payoutsNotice: de,
  payoutsTitle: ue,
  Pending: ce,
  pleaseComeBackLater: pe,
  pleaseReachOutToSupportForAssistance: ge,
  "rangePreset.custom": "Tilpasset",
  "rangePreset.last30Days": "Siste 30 dager",
  "rangePreset.last7Days": "Siste 7 dager",
  "rangePreset.lastMonth": "Forrige måned",
  "rangePreset.lastWeek": "Forrige uke",
  "rangePreset.thisMonth": "Denne måneden",
  "rangePreset.thisWeek": "Denne uken",
  "rangePreset.yearToDate": "Hittil i år",
  reachOutToSupport: ke,
  referenceID: fe,
  refresh: me,
  refund: be,
  "refund.amountAlreadyRefunded": "Du har allerede refundert %{amount}",
  "refund.amountFailed": "Refusjonen på %{amount} mislyktes. Det er for øyeblikket ikke mulig å refundere dette beløpet. Kontakt brukerstøtten.",
  "refund.amountInProgress": "Den delvise refunderingen av %{amount} er under behandling.",
  "refund.fee": "Gebyr",
  "refund.fullAmountFailed": "Det er ikke mulig å refundere denne betalingen. Kontakt brukerstøtten.",
  "refund.fullAmountRefunded": "Hele beløpet er refundert til kunden",
  "refund.goToPayment": "Gå til betaling",
  "refund.maximumRefundable": "Du kan bare refundere maksimalt %{amount}",
  "refund.onlyRefundable": "Du kan bare refundere %{amount}",
  "refund.originalAmount": "Opprinnelig beløp",
  "refund.originalPayment": "Opprinnelig betaling",
  "refund.paymentPspReference": "Betalingsleverandørreferanse",
  "refund.pspReference": "PSP-referanse",
  "refund.refundFee": "Refusjonsgebyr",
  "refund.refundPspReference": "PSP-referanse for refusjonen",
  "refund.returnToRefund": "Gå tilbake til refusjon",
  "refund.theRefundIsBeingProcessed": "Refusjonen er under behandling.",
  refundAction: ve,
  refundActionErrorSubtitle: ye,
  refundActionErrorTitle: he,
  refundActionSuccessSubtitle: Te,
  refundActionSuccessTitle: Re,
  refundAmount: Ae,
  "refundAmount.excess": "Du kan ikke overskride det tilgjengelige beløpet på %{amount}",
  "refundAmount.required": "Angi et refusjonsbeløp",
  "refunded.full": "Fullt refundert",
  "refunded.partial": "Delvis refundert",
  refundNotice: Fe,
  refundPayment: Pe,
  refundReason: je,
  "refundReason.duplicate": "Duplikat",
  "refundReason.fraudulent": "Bedragersk",
  "refundReason.issue_with_item_sold": "Problem med den solgte varen",
  "refundReason.other": "Annet",
  "refundReason.requested_by_customer": "Forespurt av kunden",
  refundReference: De,
  "refundReference.placeholder": "Angi referansen her",
  remainingAmount: Se,
  report: Ne,
  "reportsError.tooManyDownloads": "Vi kunne ikke laste ned alle filene. Prøv igjen senere.",
  reportsNotice: Ce,
  reportsTitle: Oe,
  "reportType.payout": "Utbetaling",
  reset: Be,
  Reversed: Ie,
  "select.filter.placeholder": "Plassholder",
  "select.noOptionsFound": "Ingen alternativer samsvarer med dette søket",
  somethingWentWrong: Le,
  somethingWentWrongTryRefreshingOrComeBackLater: xe,
  status: we,
  structuredList: Ve,
  subtractions: We,
  sumOfSameDayPayouts: Me,
  tabs: Ke,
  theErrorCodeIs: Ge,
  thereAreNoResults: qe,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: Ee,
  thereWasAnUnexpectedError: Ue,
  theSelectedBalanceAccountIsIncorrect: He,
  timezone: Ye,
  to: _e,
  "tooltip.ATM": "Penger tatt ut i minibank",
  "tooltip.Capital": "Penger fra et innkommende lånetilskudd eller utgående tilbakebetaling av lån",
  "tooltip.Chargeback": "Penger returnert til en kunde etter en bestridt transaksjon",
  "tooltip.Correction": "Justeringer av midlene dine, inkludert reversering av transaksjoner og korrigering av innskudd",
  "tooltip.Fee": "Transaksjonskostnader og gebyrer for betalingsmetode",
  "tooltip.Other": "Transaksjoner som ikke hører til i en annen kategori, vanligvis en justering",
  "tooltip.Payment": "Penger mottatt i kontoen din fra en salgstransaksjon",
  "tooltip.Refund": "Penger sendt tilbake til en kunde fra en refundert transaksjon",
  "tooltip.totalIncoming": "Alle penger mottatt på kontoen din basert på de valgte filtrene",
  "tooltip.totalOutgoing": "Alle gebyrer, refusjoner, utbetalinger og andre kostnader basert på de valgte filtrene",
  "tooltip.Transfer": "Penger som er flyttet mellom din konto og en annen konto",
  totalIncoming: Xe,
  totalOutgoing: ze,
  toValueShouldBeGreaterThanTheFromValue: Je,
  transactionDetails: Qe,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: en,
  transfer: nn,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: tn,
  tryRefreshingThePageOrComeBackLater: an,
  txAmount: rn,
  "txType.ATM": "Minibank",
  "txType.Capital": "Kapital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Rettelse",
  "txType.Fee": "Gebyr",
  "txType.Other": "Annet",
  "txType.Payment": "Betaling",
  "txType.Refund": "Refundering",
  "txType.Transfer": "Overføring",
  type: on,
  value: sn,
  weCouldNotLoadThePayoutsOverview: ln,
  weCouldNotLoadTheReportsOverview: dn,
  weCouldNotLoadTheTransactionsOverview: un,
  weCouldNotLoadYourBalanceAccounts: cn,
  weCouldNotLoadYourPayouts: pn,
  weCouldNotLoadYourReports: gn,
  weCouldNotLoadYourTransactions: kn
};
export {
  p as Booked,
  ce as Pending,
  Ie as Reversed,
  e as account,
  n as accountBalance,
  t as accountDescription,
  a as accountID,
  r as additions,
  i as adjustments,
  o as amount,
  s as and,
  l as apply,
  d as back,
  u as balanceAccount,
  c as balanceAccountId,
  g as capture,
  k as category,
  f as chargeback,
  m as closeIconLabel,
  b as contactSupport,
  v as contactSupportForHelp,
  y as contactSupportForHelpAndShareErrorCode,
  h as copied,
  T as copy,
  R as correction,
  A as currency,
  F as date,
  P as dateRange,
  fn as default,
  j as description,
  D as dismiss,
  S as download,
  N as downloading,
  C as email,
  O as entityWasNotFound,
  B as entityWasNotFoundDetail,
  I as fee,
  L as file,
  x as filterBar,
  w as from,
  V as full,
  W as fundsCaptured,
  M as goBack,
  K as grantIssued,
  G as grantRepayment,
  q as hideContent,
  E as id,
  H as inProgress,
  U as incompleteField,
  Y as loading,
  _ as max,
  X as min,
  z as mobile,
  J as netPayout,
  Q as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  ne as noReportsFound,
  te as noTransactionsFound,
  ae as other,
  re as paginatedNavigation,
  ie as partial,
  oe as paymentId,
  se as paymentMethod,
  le as payoutDetails,
  de as payoutsNotice,
  ue as payoutsTitle,
  pe as pleaseComeBackLater,
  ge as pleaseReachOutToSupportForAssistance,
  ke as reachOutToSupport,
  fe as referenceID,
  me as refresh,
  be as refund,
  ve as refundAction,
  ye as refundActionErrorSubtitle,
  he as refundActionErrorTitle,
  Te as refundActionSuccessSubtitle,
  Re as refundActionSuccessTitle,
  Ae as refundAmount,
  Fe as refundNotice,
  Pe as refundPayment,
  je as refundReason,
  De as refundReference,
  Se as remainingAmount,
  Ne as report,
  Ce as reportsNotice,
  Oe as reportsTitle,
  Be as reset,
  Le as somethingWentWrong,
  xe as somethingWentWrongTryRefreshingOrComeBackLater,
  we as status,
  Ve as structuredList,
  We as subtractions,
  Me as sumOfSameDayPayouts,
  Ke as tabs,
  Ge as theErrorCodeIs,
  Ee as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  He as theSelectedBalanceAccountIsIncorrect,
  qe as thereAreNoResults,
  Ue as thereWasAnUnexpectedError,
  Ye as timezone,
  _e as to,
  Je as toValueShouldBeGreaterThanTheFromValue,
  Xe as totalIncoming,
  ze as totalOutgoing,
  Qe as transactionDetails,
  en as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  nn as transfer,
  tn as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  an as tryRefreshingThePageOrComeBackLater,
  rn as txAmount,
  on as type,
  sn as value,
  ln as weCouldNotLoadThePayoutsOverview,
  dn as weCouldNotLoadTheReportsOverview,
  un as weCouldNotLoadTheTransactionsOverview,
  cn as weCouldNotLoadYourBalanceAccounts,
  pn as weCouldNotLoadYourPayouts,
  gn as weCouldNotLoadYourReports,
  kn as weCouldNotLoadYourTransactions
};
